import React from 'react'
import styled from 'styled-components';
import { CgClose, CgMenuRight } from "react-icons/cg"
import { AnimatePresence, motion, useCycle } from "framer-motion";
import AnimatedList from './AnimatedList';
import { useLocation } from "react-router-dom"
import { mobilenavButton } from '../../../motion-varients/mobilenav';


const StyledMobileNav = styled.nav`
`;

const StyledMenu = styled.div`
position: absolute;
top: 0;
left: 0;
height: 200%;
width: 100vw;
z-index: 1000;
background: white;

&>ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0;
    &>li{
        font-size: 2rem;
        width: 100%;
        text-align: center;
        transition: all .2s;
        &:hover{
            background-color: #f5f5f5;
        }
    }
}
`;

const StyledButton = styled(motion.div)`
    z-index: 20;
    font-size: 3rem;
    padding: .4em;
    display: flex;
    justify-content: end;
    `;

export default function MobileNav() {

    const [isOpen, toggleOpen] = useCycle(false, true);
    const location = useLocation();


    return (
        <StyledMobileNav isOpen={isOpen}>

            {!isOpen && <StyledButton onClick={() => {
                toggleOpen();
            }}><CgMenuRight />
            </StyledButton>}

            <AnimatePresence mode='wait'>
                {isOpen && <StyledMenu
                    location={location}
                    key={location.pathname}
                >
                    <StyledButton
                        initial="closed"
                        animate="open"
                        exit="closed"
                        variants={mobilenavButton}
                        onClick={() => {
                            toggleOpen();
                        }}> <CgClose />
                    </StyledButton>
                    <AnimatedList isOpen={isOpen} toggleOpen={toggleOpen} />
                </StyledMenu>}
            </AnimatePresence>



        </StyledMobileNav >
    )
}
